import * as Yup from "yup";

export const accountValidationSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Account name is too short")
    .required("Account name is required"),
  address: Yup.string().required("Account type is required"),
});
